/* とべとべくさ Shopify theme */
(function () {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTtkSite);
  } else {
    initTtkSite();
  }

  function initTtkSite() {
    setupNavigation();
    setupImageErrorHandling();
    setupCarousels();
    setupProductGallery();
    setupArtistGallery();
    setupArtistExhibitions();
    setupExhibitions();
    setupImageLightbox();
    setupNewsletterForms();
  }

  function setupNavigation() {
    var site = document.querySelector(".ttk-site");
    var navToggle = document.querySelector(".ttk-nav-toggle");

    if (!site || !navToggle) return;

    navToggle.addEventListener("click", function () {
      var isOpen = site.classList.toggle("is-nav-open");
      navToggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  function setupImageErrorHandling() {
    var images = document.querySelectorAll(".ttk-site img");
    for (var i = 0; i < images.length; i += 1) {
      images[i].addEventListener("error", function () {
        this.classList.add("is-missing");
        if (!this.alt) this.alt = "画像準備中";
      });
    }
  }

  function setupCarousels() {
    var carousels = document.querySelectorAll("[data-ttk-carousel]");
    for (var i = 0; i < carousels.length; i += 1) {
      setupCarousel(carousels[i]);
    }
  }

  function setupNewsletterForms() {
    var forms = document.querySelectorAll(".ttk-newsletter-form");

    for (var i = 0; i < forms.length; i += 1) {
      forms[i].addEventListener("submit", function (event) {
        var form = this;
        var success = form.querySelector(".ttk-newsletter-form__success");

        if (!success) return;

        if (form.hasAttribute("data-ttk-mailchimp-form")) {
          showNewsletterSuccess(form, success);
          return;
        }

        event.preventDefault();
        if (form.classList.contains("is-submitting")) return;

        var button = form.querySelector('button[type="submit"]');
        form.classList.add("is-submitting");
        if (button) {
          button.disabled = true;
          button.textContent = "登録中…";
        }

        window
          .fetch(form.action, {
            method: form.method || "post",
            body: new FormData(form),
            credentials: "same-origin",
          })
          .then(function (response) {
            if (!response.ok) throw new Error("Newsletter signup failed");
            showNewsletterSuccess(form, success);
          })
          .catch(function () {
            form.classList.remove("is-submitting");
            if (button) {
              button.disabled = false;
              button.textContent = "登録する";
            }
          });
      });
    }
  }

  function showNewsletterSuccess(form, success) {
    form.classList.remove("is-submitting");
    form.classList.add("is-submitted");
    success.hidden = false;
  }

  function setupArtistExhibitions() {
    var lists = document.querySelectorAll(
      ".ttk-artist-exhibitions-sidebar__list",
    );

    for (var i = 0; i < lists.length; i += 1) {
      var list = lists[i];
      var items = Array.prototype.slice.call(list.children);

      items.sort(function (a, b) {
        var aEnd = a.getAttribute("data-end-date") || "";
        var bEnd = b.getAttribute("data-end-date") || "";

        if (aEnd === bEnd) return 0;
        return aEnd < bEnd ? -1 : 1;
      });

      for (var j = 0; j < items.length; j += 1) {
        list.appendChild(items[j]);
      }
    }
  }

  function setupExhibitions() {
    var list = document.querySelector("[data-ttk-exhibition-list]");
    var pagination = document.querySelector("[data-ttk-exhibition-pagination]");
    if (!list || !pagination) return;

    setupRenderedExhibitionPagination(list, pagination);
    setupExhibitionContentFit(list);
  }

  function setupExhibitionContentFit(list) {
    var frame = 0;

    function scheduleFit() {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        fitExhibitionContent(list);
      });
    }

    var images = list.querySelectorAll(".ttk-exhibition-item__image");
    for (var i = 0; i < images.length; i += 1) {
      var image = images[i].querySelector("img");
      if (image && !image.complete) image.addEventListener("load", scheduleFit);
    }

    if ("ResizeObserver" in window) {
      var observer = new ResizeObserver(scheduleFit);
      for (var j = 0; j < images.length; j += 1) observer.observe(images[j]);
    }

    window.addEventListener("resize", scheduleFit);
    scheduleFit();
  }

  function fitExhibitionContent(list) {
    var items = list.querySelectorAll(".ttk-exhibition-item");

    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var image = item.querySelector(".ttk-exhibition-item__image");
      var content = item.querySelector(".ttk-exhibition-item__content");
      var excerptText = item.querySelector(
        ".ttk-exhibition-item__excerpt-text",
      );
      var detail = item.querySelector(".ttk-exhibition-item__detail");

      if (!image || !content) continue;
      if (excerptText && typeof excerptText._ttkFullText !== "string") {
        excerptText._ttkFullText = excerptText.textContent.trim();
      }

      content.style.height = "";
      if (excerptText) excerptText.textContent = excerptText._ttkFullText;
      if (detail) detail.hidden = true;

      if (item.hidden || item.offsetParent === null) continue;

      var imageHeight = Math.round(image.getBoundingClientRect().height);
      if (!imageHeight) continue;
      content.style.height = imageHeight + "px";

      if (
        !excerptText ||
        !detail ||
        content.scrollHeight <= content.clientHeight
      ) {
        continue;
      }

      detail.hidden = false;
      var fullText = excerptText._ttkFullText;
      var low = 0;
      var high = fullText.length;

      while (low < high) {
        var middle = Math.ceil((low + high) / 2);
        excerptText.textContent = fullText.slice(0, middle).trimEnd() + "…";

        if (content.scrollHeight <= content.clientHeight) low = middle;
        else high = middle - 1;
      }

      excerptText.textContent = fullText.slice(0, low).trimEnd() + "…";
    }
  }

  function setupRenderedExhibitionPagination(list, pagination) {
    var pageSize =
      Number(list.getAttribute("data-ttk-exhibition-page-size")) || 8;
    var items = Array.prototype.slice.call(
      list.querySelectorAll(".ttk-exhibition-item"),
    );
    var mode = getExhibitionMode(list);
    items = filterRenderedExhibitionItems(items, mode);
    enhanceRenderedExhibitionItems(items);
    var siblings = Array.prototype.slice.call(list.children);
    var currentPage = 1;
    var totalPages = Math.max(1, Math.ceil(items.length / pageSize));

    if (!items.length) return;

    function render() {
      var start = (currentPage - 1) * pageSize;
      var end = start + pageSize;

      for (var s = 0; s < siblings.length; s += 1) {
        siblings[s].hidden = true;
        siblings[s].style.display = "none";
      }

      for (var i = 0; i < items.length; i += 1) {
        var shouldHide = i < start || i >= end;
        items[i].hidden = shouldHide;
        items[i].style.display = shouldHide ? "none" : "";
      }

      renderPagination(
        pagination,
        currentPage,
        totalPages,
        function (nextPage) {
          currentPage = nextPage;
          render();
          scrollToWithHeader(list);
        },
      );
    }

    render();
  }

  function filterRenderedExhibitionItems(items, mode) {
    return items.filter(function (item) {
      return shouldShowExhibition(
        item.getAttribute("data-start-date"),
        item.getAttribute("data-end-date"),
        mode,
      );
    });
  }

  function compareExhibitionDates(a, b, mode) {
    var first = String(a || "");
    var second = String(b || "");
    if (mode === "past") return second.localeCompare(first);
    return first.localeCompare(second);
  }

  function getExhibitionMode(list) {
    return list.getAttribute("data-ttk-exhibition-mode") === "past"
      ? "past"
      : "current_upcoming";
  }

  function shouldShowExhibition(from, to, mode) {
    var today = new Date();
    var start = parseDate(from);
    var end = parseDate(to);
    today.setHours(0, 0, 0, 0);

    if (!start && !end) return false;
    if (!end) end = start;
    end.setHours(23, 59, 59, 999);

    if (mode === "past") return end < today;
    return end >= today;
  }

  function enhanceRenderedExhibitionItems(items) {
    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      var image = item.querySelector(".ttk-exhibition-item__image");
      var content = item.querySelector(".ttk-exhibition-item__content");

      if (!image) {
        image = document.createElement("span");
        image.className =
          "ttk-exhibition-item__image ttk-exhibition-item__image--fallback";
        image.setAttribute("aria-hidden", "true");
        item.insertBefore(image, item.firstChild);
      }

      item.classList.add("has-image");

      if (!content) {
        content = document.createElement("div");
        content.className = "ttk-exhibition-item__content";

        var title = item.querySelector("h2");
        var meta = item.querySelector(".ttk-meta");

        if (title) content.appendChild(title);
        if (meta) content.appendChild(meta);

        while (item.childNodes.length > 1) {
          var node = item.childNodes[1];
          if (node === content) break;
          content.appendChild(node);
        }

        item.appendChild(content);
      }
    }
  }

  function renderPagination(container, currentPage, totalPages, onChange) {
    container.innerHTML = "";
    if (totalPages <= 1) return;

    container.appendChild(
      createPaginationButton("<", currentPage > 1, function () {
        onChange(currentPage - 1);
      }),
    );

    for (var i = 1; i <= totalPages; i += 1) {
      (function (page) {
        var button = createPaginationButton(
          String(page),
          page !== currentPage,
          function () {
            onChange(page);
          },
        );
        if (page === currentPage) button.setAttribute("aria-current", "page");
        container.appendChild(button);
      })(i);
    }

    container.appendChild(
      createPaginationButton(">", currentPage < totalPages, function () {
        onChange(currentPage + 1);
      }),
    );
  }

  function createPaginationButton(label, enabled, onClick) {
    var button = document.createElement("button");
    button.type = "button";
    button.textContent = label;
    button.disabled = !enabled;
    if (enabled) button.addEventListener("click", onClick);
    return button;
  }

  function scrollToWithHeader(element) {
    var header = document.querySelector(".ttk-header");
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var top =
      element.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight -
      18;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  function parseDate(value) {
    var parts = String(value || "").split("-");
    if (parts.length !== 3) return null;
    var date = new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2]),
    );
    return Number.isNaN(date.getTime()) ? null : date;
  }

  function setupProductGallery() {
    var media = document.querySelector("[data-ttk-product-media]");
    var mainImage = document.querySelector("[data-ttk-product-main-image]");
    var thumbsWrap = document.querySelector("[data-ttk-product-thumbs]");
    if (!media || !thumbsWrap) return;

    appendProductVideos(thumbsWrap);
    bindProductGalleryThumbs(media, thumbsWrap, mainImage);
    preloadProductGalleryImages(thumbsWrap, mainImage);
  }

  function preloadProductGalleryImages(thumbsWrap, mainImage) {
    function preload() {
      var thumbs = thumbsWrap.querySelectorAll("[data-ttk-thumb-src]");
      var loadedSources = {};
      var currentSrc = mainImage && (mainImage.currentSrc || mainImage.src);
      thumbsWrap.ttkProductPreloads = [];

      if (currentSrc) loadedSources[currentSrc] = true;

      for (var i = 0; i < thumbs.length; i += 1) {
        var source = thumbs[i].getAttribute("data-ttk-thumb-src");
        if (!source) continue;

        var absoluteSource = new URL(source, document.baseURI).href;
        if (loadedSources[absoluteSource]) continue;
        loadedSources[absoluteSource] = true;

        var image = new Image();
        image.decoding = "async";
        image.fetchPriority = "low";
        image.onload = image.onerror = function () {
          var index = thumbsWrap.ttkProductPreloads.indexOf(this);
          if (index !== -1) thumbsWrap.ttkProductPreloads.splice(index, 1);
        };
        thumbsWrap.ttkProductPreloads.push(image);
        image.src = absoluteSource;
      }
    }

    function schedulePreload() {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(preload, { timeout: 2000 });
      } else {
        window.setTimeout(preload, 0);
      }
    }

    if (document.readyState === "complete") {
      schedulePreload();
    } else {
      window.addEventListener("load", schedulePreload, { once: true });
    }
  }

  function setupArtistGallery() {
    var galleries = document.querySelectorAll("[data-ttk-artist-gallery]");

    for (var g = 0; g < galleries.length; g += 1) {
      setupArtistGalleryCarousel(galleries[g]);
    }
  }

  function setupArtistGalleryCarousel(gallery) {
    var main = gallery.querySelector("[data-ttk-artist-gallery-main]");
    if (!main) return;

    var mainImage = main.querySelector("img");
    var caption = gallery.querySelector("[data-ttk-artist-gallery-caption]");
    var thumbsWrap = gallery.querySelector(".ttk-artist-gallery__thumbs");
    var thumbs = gallery.querySelectorAll("[data-ttk-artist-gallery-thumb]");
    var previous = gallery.querySelector("[data-ttk-artist-gallery-previous]");
    var next = gallery.querySelector("[data-ttk-artist-gallery-next]");
    var imageCache = {};
    var selectionVersion = 0;
    if (!mainImage || !thumbsWrap || !thumbs.length) return;

    function loadGalleryImage(source, priority) {
      var absoluteSource = new URL(source, document.baseURI).href;
      var cached = imageCache[absoluteSource];

      if (cached) {
        if (priority === "high") cached.image.fetchPriority = "high";
        return cached.promise;
      }

      var image = new Image();
      image.decoding = "async";
      image.fetchPriority = priority || "low";

      var promise = new Promise(function (resolve, reject) {
        image.onload = function () {
          if (typeof image.decode === "function") {
            image.decode().catch(function () {}).then(function () {
              resolve(image);
            });
          } else {
            resolve(image);
          }
        };
        image.onerror = reject;
      });

      imageCache[absoluteSource] = { image: image, promise: promise };
      image.src = absoluteSource;
      return promise;
    }

    function preloadGalleryImages() {
      for (var i = 0; i < thumbs.length; i += 1) {
        var source = thumbs[i].getAttribute("data-ttk-artist-gallery-src");
        if (source) loadGalleryImage(source, "low").catch(function () {});
      }
    }

    function syncControls() {
      if (!mainImage.naturalWidth || !mainImage.naturalHeight) return;

      var frameWidth = main.clientWidth;
      var frameHeight = main.clientHeight;
      var imageRatio = mainImage.naturalWidth / mainImage.naturalHeight;
      var frameRatio = frameWidth / frameHeight;
      var renderedWidth =
        imageRatio > frameRatio ? frameWidth : frameHeight * imageRatio;
      var imageInset = Math.max(0, (frameWidth - renderedWidth) / 2);

      main.style.setProperty(
        "--ttk-gallery-image-inset",
        Math.round(imageInset) + "px",
      );
      gallery.style.setProperty(
        "--ttk-gallery-image-width",
        Math.round(renderedWidth) + "px",
      );
    }

    function selectThumb(thumb) {
      var src = thumb.getAttribute("data-ttk-artist-gallery-src");
      var lightboxSrc = thumb.getAttribute(
        "data-ttk-artist-gallery-lightbox-src",
      );
      var nextCaption =
        thumb.getAttribute("data-ttk-artist-gallery-caption") || "";
      if (!src) return;

      selectionVersion += 1;
      var currentSelection = selectionVersion;
      main.classList.add("is-loading");
      main.setAttribute("aria-busy", "true");

      loadGalleryImage(src, "high").then(function (loadedImage) {
        if (currentSelection !== selectionVersion) return;

        mainImage.removeAttribute("srcset");
        mainImage.removeAttribute("sizes");
        mainImage.src = loadedImage.src;
        mainImage.alt = nextCaption;
        if (lightboxSrc) {
          main.setAttribute("data-ttk-artist-lightbox-src", lightboxSrc);
        }
        if (caption) caption.textContent = nextCaption;
        main.classList.remove("is-loading");
        main.removeAttribute("aria-busy");
        syncControls();
      }).catch(function () {
        if (currentSelection !== selectionVersion) return;
        main.classList.remove("is-loading");
        main.removeAttribute("aria-busy");
      });

      for (var t = 0; t < thumbs.length; t += 1) {
        thumbs[t].classList.remove("is-active");
      }
      thumb.classList.add("is-active");
    }

    function move(direction) {
      var activeIndex = 0;
      for (var i = 0; i < thumbs.length; i += 1) {
        if (thumbs[i].classList.contains("is-active")) activeIndex = i;
      }
      selectThumb(thumbs[(activeIndex + direction + thumbs.length) % thumbs.length]);
    }

    mainImage.addEventListener("load", syncControls);
    window.addEventListener("resize", syncControls);
    if (mainImage.complete) syncControls();

    if (document.readyState === "complete") {
      preloadGalleryImages();
    } else {
      window.addEventListener("load", preloadGalleryImages, { once: true });
    }

    for (var i = 0; i < thumbs.length; i += 1) {
      thumbs[i].addEventListener("click", function () {
        selectThumb(this);
      });
    }

    if (previous) {
      previous.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(-1);
      });
    }

    if (next) {
      next.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        move(1);
      });
    }
  }

  function bindProductGalleryThumbs(media, thumbsWrap, mainImage) {
    var thumbs = thumbsWrap.querySelectorAll(
      "[data-ttk-product-thumb], [data-ttk-product-video-thumb], [data-ttk-product-native-video-thumb]",
    );
    for (var i = 0; i < thumbs.length; i += 1) {
      thumbs[i].addEventListener("click", function () {
        var nextSrc = this.getAttribute("data-ttk-thumb-src");
        var videoSrc = this.getAttribute("data-ttk-video-src");
        var nativeVideoTemplate = this.getAttribute(
          "data-ttk-native-video-template",
        );
        var aspectRatio = this.getAttribute("data-ttk-media-aspect-ratio");
        var thumbImage = this.querySelector("img");

        if (nativeVideoTemplate) {
          if (aspectRatio) {
            media.style.setProperty(
              "--ttk-product-media-aspect-ratio",
              aspectRatio,
            );
          }
          showProductNativeVideo(media, nativeVideoTemplate);
          mainImage = null;
        } else if (videoSrc) {
          media.style.setProperty("--ttk-product-media-aspect-ratio", "9 / 16");
          showProductVideo(
            media,
            videoSrc,
            this.getAttribute("data-ttk-video-title"),
          );
        } else if (nextSrc) {
          if (aspectRatio) {
            media.style.setProperty(
              "--ttk-product-media-aspect-ratio",
              aspectRatio,
            );
          }
          showProductImage(
            media,
            mainImage,
            nextSrc,
            this.getAttribute("data-ttk-lightbox-src") || nextSrc,
            thumbImage,
          );
          mainImage = media.querySelector("[data-ttk-product-main-image]");
        } else {
          return;
        }

        for (var t = 0; t < thumbs.length; t += 1) {
          thumbs[t].classList.remove("is-active");
        }
        this.classList.add("is-active");
      });
    }
  }

  function appendProductVideos(thumbsWrap) {
    var videos = collectProductVideos();
    for (var i = 0; i < videos.length; i += 1) {
      var button = document.createElement("button");
      var image = document.createElement("img");

      button.type = "button";
      button.className = "ttk-detail-thumbs__video";
      button.setAttribute("data-ttk-product-video-thumb", "");
      button.setAttribute("data-ttk-video-src", videos[i].src);
      button.setAttribute("data-ttk-video-title", videos[i].title);
      button.setAttribute("aria-label", "動画を表示");
      image.src =
        "https://i.ytimg.com/vi/" +
        encodeURIComponent(videos[i].id) +
        "/hqdefault.jpg";
      image.alt = videos[i].title;
      button.appendChild(image);
      thumbsWrap.appendChild(button);
    }
  }

  function collectProductVideos() {
    var sources = document.querySelectorAll(
      "[data-ttk-product-video], .ttk-detail-description iframe[src*='youtube.com'], .ttk-detail-description iframe[src*='youtu.be'], .ttk-purchase-panel iframe[src*='youtube.com'], .ttk-purchase-panel iframe[src*='youtu.be']",
    );
    var videos = [];
    var videoIds = {};

    for (var i = 0; i < sources.length; i += 1) {
      var videoUrl =
        sources[i].getAttribute("data-ttk-video-url") ||
        sources[i].getAttribute("src");
      var videoId = extractYoutubeId(videoUrl);
      if (!videoId) continue;
      if (videoIds[videoId]) {
        sources[i].remove();
        continue;
      }

      videoIds[videoId] = true;
      videos.push({
        id: videoId,
        src: buildYoutubeEmbedUrl(videoId),
        title:
          sources[i].getAttribute("data-ttk-video-title") ||
          sources[i].getAttribute("title") ||
          "YouTube Shorts",
      });
      sources[i].remove();
    }

    return videos;
  }

  function extractYoutubeId(url) {
    if (!url) return "";
    var value = String(url).replace(/&amp;/g, "&");
    var match = value.match(
      /(?:embed\/|shorts\/|watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{6,})/,
    );
    return match ? match[1] : "";
  }

  function buildYoutubeEmbedUrl(videoId) {
    var id = encodeURIComponent(videoId);
    return (
      "https://www.youtube.com/embed/" +
      id +
      "?autoplay=1&mute=1&controls=0&playsinline=1&rel=0"
    );
  }

  function showProductImage(
    media,
    mainImage,
    nextSrc,
    lightboxSrc,
    thumbImage,
  ) {
    var image =
      (mainImage && media.contains(mainImage)
        ? mainImage
        : media.querySelector("[data-ttk-product-main-image]")) ||
      document.createElement("img");
    image.removeAttribute("srcset");
    image.removeAttribute("sizes");
    image.src = nextSrc;
    image.alt = thumbImage && thumbImage.alt ? thumbImage.alt : "";
    image.setAttribute("data-ttk-product-main-image", "");
    media.setAttribute("data-ttk-detail-lightbox-src", lightboxSrc);
    media.innerHTML = "";
    media.appendChild(image);
  }

  function showProductNativeVideo(media, templateId) {
    var template = document.getElementById(templateId);
    var templateVideo =
      template && template.content
        ? template.content.querySelector("video")
        : null;
    if (!templateVideo) return;

    var video = templateVideo.cloneNode(true);
    media.removeAttribute("data-ttk-detail-lightbox-src");
    media.innerHTML = "";
    media.appendChild(video);

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function showProductVideo(media, src, title) {
    var iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.title = title || "YouTube Shorts";
    iframe.loading = "lazy";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.allowFullscreen = true;

    media.innerHTML = "";
    media.appendChild(iframe);
  }

  function setupImageLightbox() {
    var links = document.querySelectorAll("[data-ttk-lightbox-image]");
    var artistImages = document.querySelectorAll(
      "[data-ttk-artist-lightbox-src]",
    );
    var detailImages = document.querySelectorAll(".ttk-detail-media img");
    var productMedia = document.querySelectorAll("[data-ttk-product-media]");
    if (
      !links.length &&
      !artistImages.length &&
      !detailImages.length &&
      !productMedia.length
    ) return;

    var lightbox = document.createElement("div");
    var stage = document.createElement("div");
    var image = document.createElement("img");
    var close = document.createElement("button");
    var zoomLevels = [1, 1.5, 2.5];
    var zoomIndex = 0;
    var focusX = 0.5;
    var focusY = 0.5;
    var dragStartX = 0;
    var dragStartY = 0;
    var scrollStartX = 0;
    var scrollStartY = 0;
    var isDragging = false;
    var didDrag = false;

    lightbox.className = "ttk-lightbox";
    lightbox.setAttribute("role", "dialog");
    lightbox.setAttribute("aria-modal", "true");
    lightbox.setAttribute("aria-hidden", "true");

    stage.className = "ttk-lightbox__stage";
    image.className = "ttk-lightbox__image";
    image.tabIndex = 0;
    image.setAttribute("role", "button");
    image.setAttribute("aria-label", "クリックで拡大。拡大後はドラッグで移動");

    close.type = "button";
    close.className = "ttk-lightbox__close";
    close.setAttribute("aria-label", "閉じる");
    close.textContent = "×";

    stage.appendChild(image);
    lightbox.appendChild(stage);
    lightbox.appendChild(close);
    document.body.appendChild(lightbox);

    document.addEventListener("click", function (event) {
      var link = event.target.closest("[data-ttk-lightbox-image]");
      var artistImage = event.target.closest(
        "[data-ttk-artist-lightbox-src]",
      );
      var detailImage = event.target.closest(".ttk-detail-media img");
      var source = "";
      var alt = "";

      if (link) {
        var thumb = link.querySelector("img");
        source = link.href;
        alt = thumb && thumb.alt ? thumb.alt : "";
      } else if (artistImage) {
        var artistThumb = artistImage.querySelector("img");
        source = artistImage.getAttribute("data-ttk-artist-lightbox-src") || "";
        alt = artistThumb && artistThumb.alt ? artistThumb.alt : "";
      } else if (detailImage) {
        var media = detailImage.closest(".ttk-detail-media");
        source =
          media.getAttribute("data-ttk-detail-lightbox-src") ||
          detailImage.currentSrc ||
          detailImage.src;
        alt = detailImage.alt || "";
      }

      if (!source) return;
      event.preventDefault();
      openLightbox(source, alt);
    });

    function openLightbox(source, alt) {
      zoomIndex = 0;
      focusX = 0.5;
      focusY = 0.5;
      image.src = source;
      image.alt = alt;
      image.classList.remove("is-max-zoom");
      lightbox.classList.add("is-open");
      lightbox.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("ttk-lightbox-open");
      if (image.complete) applyZoom();
      close.focus();
    }

    function applyZoom() {
      if (!image.naturalWidth || !image.naturalHeight) return;

      var padding = window.innerWidth <= 560 ? 24 : 64;
      var availableWidth = Math.max(1, window.innerWidth - padding);
      var availableHeight = Math.max(1, window.innerHeight - padding);
      var fitScale = Math.min(
        1,
        availableWidth / image.naturalWidth,
        availableHeight / image.naturalHeight,
      );
      var zoom = zoomLevels[zoomIndex];
      var width = Math.round(image.naturalWidth * fitScale * zoom);
      var height = Math.round(image.naturalHeight * fitScale * zoom);

      image.style.width = width + "px";
      image.style.height = height + "px";
      image.classList.toggle("is-max-zoom", zoomIndex === 2);
      image.setAttribute(
        "aria-label",
        zoomIndex === 2 ? "元の倍率に戻す" : "画像をさらに拡大",
      );
      stage.style.width = Math.max(window.innerWidth, width + padding) + "px";
      stage.style.height =
        Math.max(window.innerHeight, height + padding) + "px";

      window.requestAnimationFrame(function () {
        var imageLeft = Math.max(0, (stage.offsetWidth - width) / 2);
        var imageTop = Math.max(0, (stage.offsetHeight - height) / 2);
        lightbox.scrollLeft = Math.max(
          0,
          Math.min(
            stage.offsetWidth - lightbox.clientWidth,
            imageLeft + width * focusX - lightbox.clientWidth / 2,
          ),
        );
        lightbox.scrollTop = Math.max(
          0,
          Math.min(
            stage.offsetHeight - lightbox.clientHeight,
            imageTop + height * focusY - lightbox.clientHeight / 2,
          ),
        );
      });
    }

    function cycleZoom() {
      zoomIndex = (zoomIndex + 1) % zoomLevels.length;
      applyZoom();
    }

    image.addEventListener("load", applyZoom);
    image.addEventListener("click", function (event) {
      event.stopPropagation();
      if (didDrag) {
        didDrag = false;
        return;
      }
      focusX = Math.min(1, Math.max(0, event.offsetX / image.clientWidth));
      focusY = Math.min(1, Math.max(0, event.offsetY / image.clientHeight));
      cycleZoom();
    });

    image.addEventListener("pointerdown", function (event) {
      if (zoomIndex === 0 || event.button !== 0) return;
      isDragging = true;
      didDrag = false;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      scrollStartX = lightbox.scrollLeft;
      scrollStartY = lightbox.scrollTop;
      image.setPointerCapture(event.pointerId);
      image.classList.add("is-dragging");
      event.preventDefault();
    });

    image.addEventListener("pointermove", function (event) {
      if (!isDragging) return;
      var deltaX = event.clientX - dragStartX;
      var deltaY = event.clientY - dragStartY;
      if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) didDrag = true;
      lightbox.scrollLeft = scrollStartX - deltaX;
      lightbox.scrollTop = scrollStartY - deltaY;
    });

    function stopImageDrag(event) {
      if (!isDragging) return;
      isDragging = false;
      image.classList.remove("is-dragging");
      if (event && image.hasPointerCapture(event.pointerId)) {
        image.releasePointerCapture(event.pointerId);
      }
    }

    image.addEventListener("pointerup", stopImageDrag);
    image.addEventListener("pointercancel", stopImageDrag);

    image.addEventListener(
      "wheel",
      function (event) {
        event.preventDefault();
        focusX = Math.min(1, Math.max(0, event.offsetX / image.clientWidth));
        focusY = Math.min(1, Math.max(0, event.offsetY / image.clientHeight));
        if (event.deltaY < 0 && zoomIndex < zoomLevels.length - 1) zoomIndex += 1;
        if (event.deltaY > 0 && zoomIndex > 0) zoomIndex -= 1;
        applyZoom();
      },
      { passive: false },
    );

    image.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      cycleZoom();
    });

    window.addEventListener("resize", function () {
      if (lightbox.classList.contains("is-open")) applyZoom();
    });

    lightbox.addEventListener("click", function (event) {
      if (
        event.target === lightbox ||
        event.target === stage ||
        event.target === close
      ) {
        closeLightbox(lightbox, stage, image);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && lightbox.classList.contains("is-open")) {
        closeLightbox(lightbox, stage, image);
      }
    });
  }

  function closeLightbox(lightbox, stage, image) {
    lightbox.classList.remove("is-open");
    lightbox.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("ttk-lightbox-open");
    image.removeAttribute("src");
    image.removeAttribute("alt");
    image.removeAttribute("style");
    image.classList.remove("is-max-zoom");
    image.classList.remove("is-dragging");
    stage.removeAttribute("style");
  }

  function setupCarousel(carousel) {
    var slides = carousel.querySelectorAll(".ttk-carousel__slide");
    var prev = carousel.querySelector("[data-ttk-carousel-prev]");
    var next = carousel.querySelector("[data-ttk-carousel-next]");
    var dotsWrap = carousel.querySelector(".ttk-carousel__dots");
    var current = 0;
    var timer = 0;
    var dots = [];

    if (slides.length < 2 || !dotsWrap) return;

    for (var i = 0; i < slides.length; i += 1) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.setAttribute("aria-label", String(i + 1) + "枚目を表示");
      dot.setAttribute("data-slide-index", String(i));
      dot.addEventListener("click", function () {
        show(Number(this.getAttribute("data-slide-index")), true);
      });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }

    function show(index, shouldReset) {
      slides[current].classList.remove("is-active");
      dots[current].setAttribute("aria-current", "false");
      current = (index + slides.length) % slides.length;
      slides[current].classList.add("is-active");
      dots[current].setAttribute("aria-current", "true");
      if (shouldReset) restart();
    }

    function restart() {
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        show(current + 1, false);
      }, 5000);
    }

    if (prev) {
      prev.addEventListener("click", function () {
        show(current - 1, true);
      });
    }

    if (next) {
      next.addEventListener("click", function () {
        show(current + 1, true);
      });
    }

    dots[0].setAttribute("aria-current", "true");
    restart();
  }
})();
